<template>
  <div class="topbar">
    <KeywordFilter :lookup="'blacklists/fetch'" :limit="blacklistLimit"/>
    <div class="topbar__cell">
      <counters>
        <template slot="total">{{blacklistedList.total}}</template>
      </counters>
      <!--<div class="buttonset">
        <router-link class="btn btn--main" :to="{ name: 'add-blacklist' }">{{ $t('top_bar.add_new_blacklisted_vehicle') }}</router-link>
      </div>-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Autocomplete from 'common/Autocomplete';
import Counters from 'common/Counters';
import Messages from 'common/Messages';
import KeywordFilter from 'common/KeywordFilter';

export default {
  components: {
    Autocomplete,
    Counters,
    Messages,
    KeywordFilter,
  },
  data() {
    return {
    };
  },
  computed: mapGetters({
    blacklistedList: 'landlord/blacklists/blacklists',
    blacklistLimit: 'landlord/blacklists/limit',
  }),
};
</script>

<style lang="scss" scoped>
.messages {
  margin-right: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/blacklist/Topbar.vue